import {styled} from '@mui/material/styles'
const PREFIX = 'SignInPageComponent'

export const classes = {
  hpLogo: `${PREFIX}-hpLogo`,
  loginBtn: `${PREFIX}-loginBtn`,
  deloitteLogo: `${PREFIX}-deloitteLogo`,
  loginBtnComponent: `${PREFIX}-loginBtnComponent`,
  cookiesContainer: `${PREFIX}-cookiesContainer`,
  cookiesBtn: `${PREFIX}-cookiesBtn`,
  cookieSettingsBtn: `${PREFIX}-cookieSettingsBtn`
}

export const Root = styled('div')(({theme}) => ({
  [`& .${classes.hpLogo}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'center',
    paddingTop: '5%'
  },

  [`& .${classes.loginBtn}`]: {
    display: 'flex',
    paddingTop: '10%',
    alignContent: 'center',
    justifyContent: 'center'
  },

  [`& .${classes.cookiesContainer}`]: {
    textAlign: 'center',
    margin: 'auto',
    display: 'table',
    verticalAlign: 'middle'
  },

  [`& .${classes.cookiesBtn}`]: {
    color: theme.palette.hpAccentBlack,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.1px',
    textTransform: 'none'
  },

  [`& .${classes.cookieSettingsBtn}`]: {
    marginLeft: theme.spacing(2)
  },

  [`& .${classes.deloitteLogo}`]: {
    display: 'flex',
    alignContent: 'bottom',
    justifyContent: 'right',
    position: 'absolute',
    right: '10px',
    top: '0px'
  },

  [`& .${classes.loginBtnComponent}`]: {
    borderRadius: 5,
    padding: '.6% 5%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    backgroundColor: theme.palette.hpPrimaryDark,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      background: theme.palette.hpPrimaryDarkest
    },
    '& .MuiTouchRipple-child': {
      backgroundColor: theme.palette.hpPrimaryDarkest
    }
  }
}))
